<div class=" col-md-12 bottom-container tablesections KYC-notice">
    <div class="header-container box w-100">
        <div class=" col-md-12 bottom-container tablesections KYC-notices">
            <div class="media">
        
                <div class="media-body">
                    <h2 class="mb-3">KYC Info <i class='bx bx-badge-check'></i></h2>
                    <div class="col-md-12">
                        <p-table class="p2-table-columns show-columns" #dt [value]="kycData" [lazy]="true"
                           [totalRecords]="totalRecords" [loading]="loading"
                            styleClass="p-datatable-gridlines p-datatable-striped">
                            <ng-template pTemplate="header" let-columns>
                                <tr class="desktop-tr">
                                    <th [style]="{'width':'120px'}">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Created Date
                                        </div>
                                    </th>
                                    <th [style]="{'width':'120px'}">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Bank Name

                                        </div>
                                    </th>
                                    <th [style]="{'width':'120px'}">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Account-Number
                                        </div>
                                    </th>
                                    <th [style]="{'width':'120px'}">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            IFSC
                                        </div>
                                    </th>
                                    <th [style]="{'width':'120px'}">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Status
                                        </div>
                                    </th>
                                    <th [style]="{'width':'120px'}">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Action
                                        </div>
                                    </th>


                                </tr>

                                <tr class="mobile-tr">
                                    <th
                                        [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Created Date
                                        </div>
                                    </th>
                                    <th
                                        [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Bank Name

                                        </div>
                                    </th>
                                    <th
                                        [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Account-Number
                                        </div>
                                    </th>
                                    <th
                                        [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            IFSC
                                        </div>
                                    </th>
                                    <th
                                        [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Status
                                        </div>
                                    </th>
                                    <th
                                        [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Action
                                        </div>
                                    </th>


                                </tr>


                            </ng-template>
                            <ng-template pTemplate="body" let-kycData>
                                <tr class="p-selectable-row">

                                    <td>
                                        {{kycData.created_at | date:'dd/MM/yyyy'}}
                                    </td>
                                    <td>
                                        {{kycData.bankName}}

                                    </td>

                                    <td>
                                        {{kycData.accountNumber}}
                                    </td>
                                    <td>
                                        {{kycData.ifsc}}
                                    </td>

                                    <td *ngIf="kycData.status==false">
                                        Inactive
                                    </td>
                                    <td *ngIf="kycData.status==true">
                                        Active
                                    </td>
                                    <td>
                                        <button routerLink="../kyc-update/{{kycData.Id}}/0">View Details</button>
                                    </td>


                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="flex align-items-center justify-content-between">
                                    Email admin at<span><a href="mailto:support@tplsport.com"
                                            style="cursor: pointer;text-decoration: underline;">
                                            support@tplsport.com.</a></span>
                                    for adding another new KYC details
                                </div>
                            </ng-template>
                        </p-table>
                    </div>
                    </div>
            </div>
        </div>
    </div>
</div>